var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"section-links"},_vm._l((_vm.items),function(item,i){return _c('a',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll"}],key:i,attrs:{"title":_vm.$t(item.title),"href":item.href}},[_c('svg-icon',{attrs:{"name":item.icon}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea272324","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuItems.vue
// module id = 7Wxs
// module chunks = 0